module.exports = __webpack_public_path__ + "img/Connor.5da0d81d.jpeg";